<template>
  <div :class="['form-field-container', fields.componentType]">
    <template v-if="fields.componentType === 'el-input'">
      <el-input
        v-model="fields.value"
        placeholder=" "
        :type="fields.config.type"
        :disabled="fields.config.isDisabled"
        :clearable="fields.config.clearable"
        :autocomplete="fields.config.autocomplete"
        @input="handleChange"
      />
    </template>
    <template v-if="fields.componentType === 'el-number'">
      <el-input
        v-model="fields.value"
        placeholder=" "
        :type="fields.config.type"
        :disabled="fields.config.isDisabled"
        :clearable="fields.config.clearable"
        :autocomplete="fields.config.autocomplete"
        :max="fields.config.maxlength"
        :min="fields.config.minlength"
        @input="handleChange"
      />
    </template>
    <template v-if="fields.componentType === 'el-textarea'">
      <el-input
        v-model="fields.value"
        placeholder=" "
        type="textarea"
        :disabled="fields.config.isDisabled"
        :clearable="fields.config.clearable"
        :class="fields.config.className"
        @input="handleChange"
      />
    </template>
    <template v-if="fields.componentType === 'el-select'">
      <el-select :filterable="true"
v-model="fields.value"
class="filter-item"
placeholder="输入关键字搜索"
:disabled="fields.config.isDisabled"
:clearable="fields.config.clearable"
:multiple="fields.config.multiple"
:remote="fields.config.remote"
:collapse-tags="fields.config.collapseTags"
:focus="handleFocus(fields)"
:remote-method="query => remoteMethod(query, fields)"
:style="{ width: fields.config.width || '100%' }"
        @change="handleChange"
      >
        <template v-if="fields.option && fields.option.length">
          <el-option
            v-for="item in fields.option"
            :key="item.id"
            :label="item[fields.config.alias] || item.name"
            :value="item.id"
            :disabled="item.disable"
          >
            <template v-if="item.disable">
              <el-tooltip
                class="box-item"
                effect="dark"
                :content="item.disableContent || '改选项不可选' "
                placement="left"
                :show-after="200"
              >
                <span>{{ item[fields.config.alias] || item.name }}</span>
              </el-tooltip>
            </template>
            <span v-else>{{ item[fields.config.alias] || item.name }}</span>
         </el-option>
        </template>
        <el-option
          v-else
          :value="-1"
          disabled
        >
          暂无数据
        </el-option>
      </el-select>
    </template>
    <template v-if="fields.componentType === 'el-select-obejct'">
      <el-select :filterable="true"
v-model="fields.value"
class="filter-item"
placeholder="输入关键字搜索"
:disabled="fields.config.isDisabled"
:clearable="fields.config.clearable"
:multiple="fields.config.multiple"
:remote="fields.config.remote"
:collapse-tags="fields.config.collapseTags"
:value-key="fields.config.alias"
:focus="handleFocus(fields)"
:remote-method="query => remoteMethod(query, fields)"
:style="{ width: fields.config.width || '100%' }"
        @change="handleChange"
      >
        <template v-if="fields.option && fields.option.length">
          <el-option
            v-for="item in fields.option"
            :key="item.id"
            :label="item[fields.config.alias] || item.name"
            :value="item"
            :disabled="item.disable"
          >
            <template v-if="item.disable">
              <el-tooltip
                class="box-item"
                effect="dark"
                :content="item.disableContent || '改选项不可选' "
                placement="left"
                :show-after="200"
              >
                <span>{{ item[fields.config.alias] }}</span>
              </el-tooltip>
            </template>
            <span v-else>{{ item[fields.config.alias] }}</span>
         </el-option>
        </template>
        <el-option
          v-else
          :value="-1"
          disabled
        >
          暂无数据
        </el-option>
      </el-select>
    </template>
    <template v-if="fields.componentType === 'el-cascader'">
      <el-cascader :filterable="true" v-model="fields.value" placeholder="输入关键字搜索" :options="fields.option" :props="fields.config.props" :disabled="fields.config.isDisabled" :clearable="fields.config.clearable" :collapse-tags="fields.config.collapseTags" @focus="handleFocus(fields)" @change="handleChange">
        <template #default="{ data }">
          <span>{{ data.name }}</span>
        </template>
      </el-cascader>
    </template>
    <template v-if="fields.componentType === 'el-cascader-provinces'">
      <el-cascader :filterable="true" placeholder="输入关键字搜索" v-model="fields.value" :props="provincesLoad" :disabled="fields.config.isDisabled" :clearable="fields.config.clearable" @change="handleChange">
        <template #default="{ node, data }">
          <span style="display:none">{{ node.isLeaf }}</span>
          <span>{{ data.name }}</span>
        </template>
      </el-cascader>
    </template>

    <template v-if="fields.componentType === 'el-date-picker'">
      <el-date-picker
        v-model="fields.value"
        placeholder=" "
        :disabled="fields.config.isDisabled"
        :clearable="fields.config.clearable"
        :type="fields.config.type"
        :format="fields.config.format"
        :value-format="fields.config.valueFormat"
        @change="handleChange"
      >
      </el-date-picker>
    </template>
    <template v-if="fields.componentType === 'el-tag'">
      <el-select :filterable="true"
v-model="fields.value"
class="filter-item"
placeholder="输入关键字搜索"
:disabled="fields.config.isDisabled"
:clearable="fields.config.clearable"
multiple
allow-create
remote
:collapse-tags="fields.config.collapseTags"
:focus="handleFocus(fields)"
:remote-method="query => remoteTagMethod(query, fields)"
        @change="handleChange"
      >
      <el-option
        v-for="item in fields.option"
        :key="item"
        :label="item"
        :value="item"
      />
      </el-select>

    </template>
    <template v-if="fields.componentType === 'el-autocomplete'">
      <el-autocomplete
        v-model="fields.value"
        placeholder="输入关键字搜索"
        :disabled="fields.config.isDisabled"
        :clearable="fields.config.clearable"
        :fetch-suggestions="(query, cb) => remoteFetchSuggestions(query, fields, cb)"
        @input="handleChange"
      />
    </template>
    <template v-if="fields.componentType === 'el-contacts-group'">
      <el-select :filterable="true"
v-model="fields.value"
class="filter-item"
placeholder="输入关键字搜索"
:disabled="fields.config.isDisabled"
:clearable="fields.config.clearable"
:multiple="fields.config.multiple"
:remote="fields.config.remote"
:collapse-tags="fields.config.collapseTags"
:focus="groupRemoteMethod('', fields)"
:remote-method="query => groupRemoteMethod(query, fields)"
        @change="handleChange"
:style="{ width: fields.config.width || 'auto' }"
      >
        <el-option-group
          v-for="group in fields.option"
          :key="group.companyId"
          :label="group.companyName"
        >
          <el-option
            v-for="item in group.contacts"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.disable"
          >
           {{item.name}}
          </el-option>
        </el-option-group>
      </el-select>
    </template>
    <template v-if="fields.componentType === 'el-upload'">
      <ZUpload :option="fields" @changed="handleUploadChange($event, fields)" :value="fields.value"/>
    </template>
    <template v-if="fields.componentType === 'el-json'">
      <div class="code-viewer-container" >
        <CodeEditor v-model="fields.value" :defaultValue="fields.value" @update:modelValue="handleCodeEditorChange($event, fields)"/>
        <json-viewer
          :value="fields.config.codevalue"
          :expand-depth=5
          copyable
        />
      </div>
    </template>
    <template v-if="fields.componentType === 'el-tree'">
      <el-tree-select :filterable="true"
:data="fields.option"
:render-after-expand="false"
v-model="fields.value"
placeholder="输入关键字搜索"
check-strictly
:node-key="fields.config.nodeKey || 'id'"
:props="fields.config.treeProps || { children: 'children', label: 'name' }"
:disabled="fields.config.isDisabled"
:clearable="fields.config.clearable"
@change="handleChange" />
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted, PropType } from 'vue'
import { ElMessage } from 'element-plus'

import { getDropdownByType } from '@/apis/tool'
import { getSysAreaListByNo } from '@/apis/sysArea'
import { getTree, getPageList } from '@/apis/Form'

import { FormFieldListModel } from '@/model/FormModel'
import ZUpload from './ZUpload.vue'
import { debounce } from 'lodash'
import CodeEditor from './CodeEditor.vue'
import JsonViewer from 'vue-json-viewer'

import 'vue-json-viewer/style.css'
export default defineComponent({
  components: {
    ZUpload,
    CodeEditor,
    JsonViewer
  },
  props: {
    id: { type: Number, required: true },
    fields: { type: Object as PropType<FormFieldListModel>, required: true }
  },
  emits: ['form-change'],
  setup(props, context) {
    const dataMap = reactive({
      handleChange(val: any) {
        console.log(val, 'val')
        context.emit('form-change')
      },
      handleUploadChange(val: any, fields: any) {
        fields.value = val
      },
      groupRemoteMethod: debounce((query: string | number, fields: any) => {
        const params = { name: query }
        getPageList(fields.config.url, params).then((res: any) => {
          const oldOption = [] as any
          const newOption = [] as any
          fields.option.forEach((item: any) => {
            item.contacts && item.contacts.filter((concat: any) => {
              if (fields.value && fields.value.indexOf(concat.id) !== -1) {
                if (!oldOption.find((k: any) => k.companyId === item.companyId)) {
                  oldOption.push(item)
                }
              }
            })
          })
          ;(res || []).forEach((item: any) => {
            item.contacts && item.contacts.filter((concat: any) => {
              if (!fields.value || fields.value.indexOf(concat.id) === -1) {
                if (!newOption.find((k: any) => k.companyId === item.companyId)) {
                  newOption.push(item)
                }
              }
            })
          })
          fields.option = [...oldOption, ...newOption]
        })
      }, 500),

      remoteMethod: debounce((query: string, fields: any) => {
        const params = {
          name: query,
          page: 1,
          size: 1000
        }
        const _configParams = fields.config.params
        if (_configParams) {
          Object.keys(_configParams).forEach(k => {
            if (k === 'id' && props.id) {
              params[_configParams[k]] = props.id
            } else {
              params[k] = _configParams[k]
            }
          })
          if ((fields.fieldKey === 'customerContactIds' || fields.fieldKey === 'customerCompanyContactId') && !_configParams.companyId) {
            return
          }
        }

        getPageList(fields.config.url, params).then((res: any) => {
          const oldOption = fields.option.filter((item: any) => {
            if (fields.config.multiple) {
              return fields.value && fields.value.indexof(item.id) !== -1
            }
            return fields.value === item.id
          })
          const newOption = (res || []).filter((item: any) => {
            if (fields.config.multiple) {
              return !fields.value || fields.value.indexof(item.id) === -1
            }
            return fields.value !== item.id
          })
          fields.option = [...oldOption, ...newOption].map((k: any) => {
            return {
              ...k,
              name: k[fields.config.label] || k.name
            }
          })
        })
      }, 200),
      remoteTagMethod: debounce((query: string, fields: any) => {
        if (!query || !fields.config.remote) {
          return
        }
        getPageList(`${fields.config.url}${query}`).then((res: any) => {
          const newOption = Array.from(new Set([...fields.value, ...res]))
          fields.option = newOption
        })
      }, 500),
      remoteFetchSuggestions: debounce((query: string, fields: any, cb: any) => {
        getPageList(`${fields.config.url}${query}`).then((res: any) => {
          const newOption = !res
            ? []
            : res.map((item: any) => {
              return {
                value: item
              }
            })
          cb(newOption)
        })
      }, 500),
      handleFocus(fields: any) {
        let _url = ''
        switch (fields.componentType) {
          case 'el-cascader':
            _url = fields.config.url
            getTree(_url).then((res: any) => {
              fields.option = res || []
            })
            break
          case 'el-select':
            if (fields.config.selectType === 2) {
              _url = fields.config.url
              const params = { page: 1, size: 999 }
              const _configParams = fields.config.params
              if (_configParams) {
                Object.keys(_configParams).forEach(k => {
                  if (k === 'id' && props.id) {
                    params[_configParams[k]] = props.id
                  } else {
                    params[k] = _configParams[k]
                  }
                })
                if ((fields.fieldKey === 'customerContactIds' || fields.fieldKey === 'customerCompanyContactId') && !_configParams.companyId) {
                  return
                }
              }

              getPageList(_url, params).then((res: any) => {
                if (fields.config.label) {
                  const options = res
                    ? res.map((k: any) => {
                      return {
                        ...k,
                        name: k[fields.config.label]
                      }
                    })
                    : []
                  if (fields.option) {
                    fields.option = options
                  }
                } else {
                  fields.option = (res.data ? res.data : res) || []
                }
                if (fields.fieldKey === 'customerCompanyId' && fields.option) {
                  fields.option.forEach((k: any) => {
                    if (!k.salesManId) {
                      k.disable = true
                    }
                  })
                } else if (fields.fieldKey === 'superId' && fields.config.fromPage === 'user' && fields.option) {
                  fields.option.unshift({
                    id: 0,
                    name: '顶级'
                  })
                }
              })
            } else if (fields.config.selectType === 1) {
              getDropdownByType(fields.config.url).then((res: any) => {
                fields.option = res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
              })
            }
            break
        }
      },
      provincesLoad: {
        lazy: true,
        label: 'name',
        value: 'name',
        lazyLoad(node: any, resolve: any) {
          const { level } = node
          const _no = level === 0 ? level : node.data.no
          getSysAreaListByNo(_no).then((res: any) => {
            const nodes = res.map((k: any) => {
              return {
                ...k,
                leaf: !k.hasChildren
              }
            })
            resolve(nodes)
          })
        }
      },
      handleCodeEditorChange(value: any, fields: any) {
        const tempStr = dataMap.toJSONStr(value)
        try {
          const tempJSON = JSON.parse(tempStr)
          fields.config.codevalue = tempJSON
        } catch (error:any) {
          ElMessage.closeAll()
          ElMessage.error('JSON格式错误！')
        }
      },
      toJSONStr(str: string) {
        if (!str) {
          return '{}'
        }
        let temp = str.replace(/([\$\w]+)\s*:/g, function(_, $1) { return '"' + $1 + '":' })
        temp = temp.replace(/'/g, '"')
        return temp
      }
    })

    onMounted(() => {
      if (props.id) {
        dataMap.handleFocus(props.fields)
        context.emit('form-change')
      }
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
<style lang="scss">
.code-viewer-container{
  display:flex;
  width:100%;
  .CodeMirror{
    flex:1;
    border:1px solid #ddd;
    height: 600px;
    pre.CodeMirror-placeholder {
      color: #999;
    }
  }
  .jv-container{
    flex:1;
    .jv-code{
      padding:0;
      padding-left:10px
    }
  }
}
</style>
